<template>
  <div class="content">
    <div class="content-select">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="select-title">
            <div class="title-img">
              <img src="@/assets/appraisal/select-icon.png" alt="">
            </div>
            <div class="title-info">
              <span>就业服务管理</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="content-header">
      <myTableSearch labelNameWidth="90px" :isOperate="true" :operateWidth="200" :formData="formData" :tableLabel="tableLabel"
                     :queryFn="queryFn" :queryParams="queryParams" @successQuery="successQuery" :searchColLg="6" ref="tableRef" dataRow="rows">
        <template slot="type" slot-scope="scope">
          <span>{{ getStationTypeLabel(scope.row.type) }}</span>
        </template>
        <template slot="tool">
          <div class="toolbar-container">
            <div class="toolbar-left">
              <div class="tool-btn" @click="handleRefresh" title="刷新">
                <img :src="refreshIcon" alt="刷新" class="toolbar-icon">
              </div>
            </div>
            <div class="toolbar-right">
              <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
              <el-button plain type="info" icon="el-icon-download" :loading="downloadTemplateLoading" @click="handleDownloadTemplate">下载模版</el-button>
              <el-upload
                  ref="uploadRef"
                  action="#"
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="handleImportFile"
                  accept=".xls,.xlsx"
                  class="import-upload"
              >
                <el-button plain type="info" icon="el-icon-upload2" :loading="importLoading">导入</el-button>
              </el-upload>
            </div>
          </div>
        </template>
        <template slot="operate" slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" size="small" type="text">编辑</el-button>
          <el-button type="text" style="color:rgb(241, 74, 63);" size="small" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </myTableSearch>
      <!-- 新增/编辑 -->
      <serviceSiteDialog v-if="isSubscribeDialog" :isDialog="isSubscribeDialog" :isEdit="isEdit" :editData="editData"
                         @handleClose="isSubscribeDialog = false" @success="handleRefresh">
      </serviceSiteDialog>
      <!-- 导入结果 -->
      <importResultDialog v-if="isImportResultDialog" :isDialog="isImportResultDialog" :resultData="importResultData"
                          @handleClose="isImportResultDialog = false">
      </importResultDialog>
    </div>
  </div>
</template>

<script>
import '@/assets/css/base.css'
import { downloadServiceSiteTemplate, importServiceSite, getServiceSiteList, deleteServiceSite } from '@/api/mapServer/serviceSite'
import { getListByDictType } from '@/api/sys/dictData'
import serviceSiteDialog from '@/views/pages/mapServer/components/serviceSiteDialog.vue'
import importResultDialog from '@/views/pages/mapServer/components/importResultDialog.vue'
import refreshIcon from '@/assets/pages/appointment/refresh.png'

export default {
  name: 'ServiceSiteList',
  components: {
    serviceSiteDialog,
    importResultDialog
  },
  data() {
    return {
      refreshIcon,
      stationTypeList: [],
      currentPage: 1,
      downloadTemplateLoading: false,
      importLoading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50]
      },
      isSubscribeDialog: false,
      isEdit: false,
      editData: {},
      isImportResultDialog: false,
      importResultData: '',
      formData: [
        {
          label: '站点类型',
          type: 'select',
          key: 'type',
          colLg: 6,
          data: []
        },
        {
          label: '名称',
          type: 'input',
          key: 'name',
          colLg: 6,
          placeholder: '请输入名称'
        },
        {
          label: '所属街镇',
          type: 'input',
          key: 'streetTown',
          colLg: 6,
          placeholder: '请输入所属街镇'
        }
      ],
      tableLabel: [
        {
          prop: 'type',
          label: '站点类型',
          width: 110
        },
        {
          prop: 'name',
          label: '名称',
          minWidth: 150
        },
        {
          prop: 'streetTown',
          label: '所属街镇',
          width: 150
        },
        {
          prop: 'address',
          label: '详细地址',
          minWidth: 250
        },
        {
          prop: 'phone',
          label: '联系电话',
          width: 150
        },
        {
          prop: 'description',
          label: '简介',
          minWidth: 200
        },
        {
          prop: 'mainServices',
          label: '主要服务',
          minWidth: 200
        },
        {
          prop: 'mainCourses',
          label: '主要培训工种',
          minWidth: 150
        },
        {
          prop: 'openTime',
          label: '开放时间',
          width: 180
        }
      ],
    }
  },
  mounted() {
    this.loadStationType()
  },
  methods: {
    async loadStationType() {
      const res = await getListByDictType('station_type')
      if (res && res.code === 200 && res.data) {
        this.stationTypeList = res.data
        const index = this.formData.findIndex(item => item.key === 'type')
        if (index !== -1) {
          const dataWithAll = [
            { dictLabel: '全部', dictValue: '' },
            ...res.data
          ]
          this.$set(this.formData[index], 'data', dataWithAll)
        }
      }
    },
    getStationTypeLabel(code) {
      if (!code && code !== 0) return '-'
      const item = this.stationTypeList.find(t => String(t.dictValue) === String(code))
      return item ? item.dictLabel : '-'
    },
    queryFn(queryParams) {
      return getServiceSiteList(queryParams)
    },
    handleRefresh() {
      this.queryParams.pageNum = 1;
      this.currentPage = 1;
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },
    handleAdd() {
      this.isEdit = false
      this.editData = {}
      this.isSubscribeDialog = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.editData = { ...row }
      this.isSubscribeDialog = true
    },
    handleDel(row) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteServiceSite({id: row.id}).then(res => {
          if (res && res.code === 200) {
            this.$message.success('删除成功')
            this.handleRefresh()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        }).catch(err => {
          console.error('删除失败', err)
          this.$message.error('删除失败')
        })
      }).catch(() => {})
    },
    handleDownloadTemplate() {
      this.downloadTemplateLoading = true
      downloadServiceSiteTemplate().then(res => {
        if (res) {
          this.downloadBlobFile(res, '就业服务导入模板.xls');
        }
      }).finally(() => {
        this.downloadTemplateLoading = false
      })
    },
    handleImportFile(file) {
      const isExcel = file.raw.type === 'application/vnd.ms-excel' ||
          file.raw.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const isLt10M = file.raw.size / 1024 / 1024 < 10

      if (!isExcel) {
        this.$message.error('只能上传 .xls 或 .xlsx 格式的文件！')
        return
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB！')
        return
      }

      this.importLoading = true
      const formData = new FormData()
      formData.append('file', file.raw)

      importServiceSite(formData).then(res => {
        if (res && res.code === 200) {
          this.importResultData = res.data
          this.isImportResultDialog = true
          this.handleRefresh()
        } else {
          this.$message.error(res.msg || '导入失败')
        }
      }).catch(err => {
        console.error('导入出错', err)
        this.$message.error('导入失败')
      }).finally(() => {
        this.importLoading = false
        this.$refs.uploadRef && this.$refs.uploadRef.clearFiles()
      })
    },
    successQuery() {
      // 可用于更新统计数据
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 16px;
  &-select{
    height: 50px;
    .select-title{
      height: 46px;
      background: url('~@/assets/appraisal/selectBg.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      gap: 12px;
      padding-left: 16px;
      .title-img{
        width: 18px;
        height: 18px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .title-info{
        color: var(--vt-c-black-mute-soft);
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  &-header{
    margin-top: 16px;
    padding: 0 24px;
    display: flex;
    flex: 1;
    flex-flow: column;
    overflow: hidden;
    /deep/.myTableSearch {
      padding: 0;
    }
  }
}

.toolbar-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;

  .toolbar-icon {
    width: 24px;
    height: 24px;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
    gap: 12px;
    .tool-btn {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      transition: all 0.2s;
      background-color: #FCFCFCFF;
    }
    .list-title {
      font-size: 14px;
      font-weight: 400;
      color:var(--vt-c-blue-soft);
    }
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 12px;

    .import-upload {
      display: inline-block;

      /deep/.el-upload {
        display: inline-block;
      }
    }

    .el-button {
      height: 36px;
      padding: 0 16px;
    }
  }
}
</style>
